<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
        <div class="col-md-12 mainheader  mainheader header-container">
            <h5>Item Creation</h5>
        </div>
        <!-- <div class="col-md-6 ">
            <ol class="breadcrum d-flex justify-content-end">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">Item Creation</li>
            </ol>
        </div> -->
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
        <div class="card">
            <!-- card body -->
            <div class="card-body">
                <!-- bootstrap tabs -->
                <div class="kliqtab">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs p-0 mb-3">
                        <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#General">General</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#ItemDetails">Item Details</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#AccountDetails">Account
                                Details</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#CustomFields">Custom
                                Fields</a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane in active p-3" id="General">
                            <!-- general continue-->
                            <div class="p-3 border mb-3">
                                <!-- general -->
                                <div class="row">
                                    <div class="col-md-6">
                                        <!--/ row -->
                                        <div class="row">
                                            <!-- col -->
                                            <div class="col-lg-12 col-md-12 col-sm-6">
                                                <div class="form-group">
                                                    <label>Item Name</label>
                                                    <input type="text" class="form-control" placeholder="Item Name">
                                                </div>
                                            </div>
                                            <!--/ col -->
                                            <!-- col -->
                                            <div class="col-lg-12 col-md-12 col-sm-6">
                                                <div class="form-group">
                                                    <label>Item Code</label>
                                                    <input type="text" class="form-control"
                                                        placeholder="Write Item Code">
                                                </div>
                                            </div>
                                            <!--/ col -->
                                            <!-- col -->
                                            <div class="col-lg-12 col-md-12 col-sm-6">
                                                <div class="form-group">
                                                    <label>EAN Code</label>
                                                    <input type="text" class="form-control" placeholder="EAN Code">
                                                </div>
                                            </div>
                                            <!--/ col -->
                                            <!-- col -->
                                            <div class="col-lg-12 col-md-12 col-sm-6">
                                                <div class="form-group">
                                                    <label>Item Alias</label>
                                                    <input type="text" class="form-control" placeholder="Item Alias">
                                                </div>
                                            </div>
                                            <!--/ col -->
                                            <!-- col -->
                                            <!--/ col -->
                                        </div>
                                        <!--/ row -->
                                    </div>
                                    <!-- col -->
                                    <div class="col-md-3">
                                        <div class="options p-3 mt-3">
                                            <div class="checkbox">
                                                <input id="Batch" type="checkbox">
                                                <label for="Batch"> Batch </label>
                                            </div>
                                            <div class="checkbox">
                                                <input id="imeino" type="checkbox">
                                                <label for="imeino"> IMEI No </label>
                                            </div>
                                            <div class="checkbox">
                                                <input id="Taka" type="checkbox">
                                                <label for="Taka"> Taka </label>
                                            </div>
                                            <div class="checkbox">
                                                <input id="multiplerates" type="checkbox">
                                                <label for="multiplerates"> Multiple Rates </label>
                                            </div>
                                            <div class="checkbox">
                                                <input id="multiplerates" type="checkbox">
                                                <label for="multiplerates"> MRP - Srate with Multiple Rates </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <!-- buttons -->
                                        <div class="d-grid gap-2 d-md-block text-center">
                                            <button class="btn btn-secondary disabled rounded-pill"
                                                type="button">Active</button>
                                            <button class="btn btn-primary redbtn rounded-pill"
                                                type="button">Block</button>
                                        </div>
                                        <!--/ buttons -->
                                        <figure class="avatarImg text-center">
                                            <img src="./assets/images/avatar1.jpg" class="rounded-circle"
                                                alt="Profile Image">
                                        </figure>
                                        <!-- buttons -->
                                        <div class="d-grid gap-2 d-md-block text-center">
                                            <button class="btn btn-outline-primary redbtn rounded-pill"
                                                type="button">Web Cam</button>
                                            <button class="btn btn-outline-primary redbtn rounded-pill"
                                                type="button">Select Image</button>
                                        </div>
                                        <!--/ buttons -->
                                    </div>
                                    <!--/ col -->
                                    <!-- col-->
                                    <!--/ col -->
                                    <!-- col -->
                                    <!--/ col -->
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-8 col-sm-6">
                                        <div class="form-group row">
                                            <div class="col-10">
                                                <label>Division</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select</option>
                                                    <option>Customer</option>
                                                    <option>Type Customer</option>
                                                    <option>Vendor</option>
                                                    <option>Relish</option>
                                                </select>
                                            </div>
                                            <div class="col-2  ">
                                                <a href="javascript:void(0)" class="formAddicon"
                                                    data-toggle="modal" data-target="#addItem"><span
                                                        class="icon-plus icomoon"></span></a>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="form-group row">
                                            <div class="col-10">
                                                <label>Category</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select</option>
                                                    <option>Customer</option>
                                                    <option>Type Customer</option>
                                                    <option>Vendor</option>
                                                    <option>Relish</option>
                                                </select>
                                            </div>
                                            <div class="col-2  ">
                                                <a href="javascript:void(0)" class="formAddicon"
                                                    data-toggle="modal" data-target="#category"><span
                                                        class="icon-plus icomoon"></span></a>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-6 col-md-8">
                                        <div class="form-group">
                                            <label>Description</label>
                                            <div class="form-line">
                                                <textarea rows="4" class="form-control no-resize"
                                                    placeholder="Please type Description..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-8 col-sm-6">
                                        <div class="form-group">
                                            <label>Sub Category</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Sub Category</option>
                                                <option>Select Item</option>
                                                <option>Select Item</option>
                                                <option>Select Item</option>
                                                <option>Select Item</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <!--/ general -->
                                <div class="row">
                                    <!-- col -->
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Manufacture</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Manufacture</option>
                                                <option>Select Item</option>
                                                <option>Select Item</option>
                                                <option>Select Item</option>
                                                <option>Select Item</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Brand</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Brand</option>
                                                <option>Select Item1</option>
                                                <option>Select Item2</option>
                                                <option>Select Item3</option>
                                                <option>Select Item4</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Size</label>
                                                    <select class="form-control show-tick ms select2"
                                                        data-placeholder="Select">
                                                        <option>Select Size</option>
                                                        <option>Select Item1</option>
                                                        <option>Select Item2</option>
                                                        <option>Select Item3</option>
                                                        <option>Select Item4</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>GST%</label>
                                                    <select class="form-control show-tick ms select2"
                                                        data-placeholder="Select">
                                                        <option>5.00</option>
                                                        <option>Select Item1</option>
                                                        <option>Select Item2</option>
                                                        <option>Select Item3</option>
                                                        <option>Select Item4</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Item Type</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Item Type</option>
                                                <option>Select Item1</option>
                                                <option>Select Item2</option>
                                                <option>Select Item3</option>
                                                <option>Select Item4</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group row">
                                            <div class="col-10">
                                                <label>HSN Code</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select</option>
                                                    <option>Customer</option>
                                                    <option>Type Customer</option>
                                                    <option>Vendor</option>
                                                    <option>Relish</option>
                                                </select>
                                            </div>
                                            <div class="col-2 pl-0 ">
                                                <a href="javascript:void(0)" class="formAddicon"
                                                    data-toggle="modal" data-target="#hsn"><span
                                                        class="icon-plus icomoon"></span></a>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Store Number</label>
                                            <input type="text" class="form-control" placeholder="Store Number">
                                        </div>
                                    </div>
                                    <!--/ col -->
                                </div>
                            </div>
                            <!--/ general continue-->
                            <!-- Branch Permissions -->
                            <div class="p-3 border">
                                <div class="row">
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Purchase Pack</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Purchase Pack</option>
                                                <option>Select Item1</option>
                                                <option>Select Item2</option>
                                                <option>Select Item3</option>
                                                <option>Select Item4</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Purchase Rate</label>
                                            <input type="text" class="form-control" placeholder="0.00">
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6 ">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                <div class="form-group">
                                                    <label>Margin (%)</label>
                                                    <input type="text" class="form-control" placeholder="0.00">
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                <div class="form-group">
                                                    <label>Sales Rate</label>
                                                    <input type="text" class="form-control" placeholder="0.00">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6">
                                        <label>&nbsp;</label>
                                        <div class="row">
                                            <div class="col-lg-9 col-md-9 align-self-center text-end">
                                                <p class="text-end">Issue Conversion Purchase Pack = Sale Pack * </p>
                                            </div>
                                            <div class="col-lg-3 col-md-3">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="1">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6">
                                        <div class="row">
                                            <div class="col-lg-8 col-md-8">
                                                <div class="form-group">
                                                    <label>Sale Pack</label>
                                                    <select class="form-control show-tick ms select2"
                                                        data-placeholder="Select">
                                                        <option>NOS</option>
                                                        <option>Select Item1</option>
                                                        <option>Select Item2</option>
                                                        <option>Select Item3</option>
                                                        <option>Select Item4</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4">
                                                <div class="form-group">
                                                    <label>&nbsp;</label>
                                                    <input type="text" class="form-control" placeholder="0.00">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6">
                                        <div class="form-group">
                                            <label>MRP</label>
                                            <input type="text" class="form-control text-end" placeholder="0.00">
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6">
                                        <div class="form-group">
                                            <label>Weight</label>
                                            <input type="text" class="form-control text-end" placeholder="0.00">
                                        </div>
                                    </div>
                                    <!--/ col -->
                                    <!-- col -->
                                    <div class="col-lg-4 col-md-6">
                                        <div class="row">
                                            <div class="col-lg-8 col-md-8">
                                                <div class="form-group">
                                                    <label>Discount</label>
                                                    <select class="form-control show-tick ms select2"
                                                        data-placeholder="Select">
                                                        <option>Select Discount</option>
                                                        <option>Select Item1</option>
                                                        <option>Select Item2</option>
                                                        <option>Select Item3</option>
                                                        <option>Select Item4</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!-- col -->
                                            <div class="col-lg-4 col-md-6">
                                                <div class="form-group">
                                                    <label>&nbsp;</label>
                                                    <input type="text" class="form-control text-end" placeholder="0.00">
                                                </div>
                                            </div>
                                            <!--/ col -->
                                        </div>
                                    </div>
                                    <!--/ col -->
                                </div>
                            </div>
                            <!--/ branch permissions -->
                        </div>
                        <div role="tabpanel" class="tab-pane" id="ItemDetails">
                            <!-- card -->
                            <div class="card">
                                <div class="card-header">
                                    <h6>Rates</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-3 col-sm-6">
                                            <div class="form-group">
                                                <label>WS Rate</label>
                                                <input type="text" class="form-control" placeholder="WS Rate">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-3 col-sm-6">
                                            <div class="form-group">
                                                <label>Dealer Rate</label>
                                                <input type="text" class="form-control" placeholder="Dealer Rate">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-3 col-sm-6">
                                            <div class="form-group">
                                                <label>SPL Rate 1</label>
                                                <input type="text" class="form-control" placeholder="SPL Rate 1">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-3 col-sm-6">
                                            <div class="form-group">
                                                <label>SPL Rate 2</label>
                                                <input type="text" class="form-control" placeholder="SPL Rate 2">
                                            </div>
                                        </div>
                                        <!--/ col -->
                                    </div>
                                </div>
                            </div>
                            <!-- /card -->
                            <form>
                                <div class="form-group">
                                    <div>
                                        <p>Report based on</p>
                                    </div>
                                    <div class="radio inlineblock m-r-20">
                                        <input type="radio" name="pack" id="purchaseback" class="with-gap"
                                            value="option1">
                                        <label for="purchaseback" class="pt-1">Purchase Pack</label>
                                    </div>
                                    <div class="radio inlineblock">
                                        <input type="radio" name="pack" id="SalePack" class="with-gap" value="option2"
                                            checked="">
                                        <label for="SalePack" class="pt-1">Sale Pack</label>
                                    </div>
                                </div>
                            </form>
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>Min Stock</label>
                                        <input type="text" class="form-control" placeholder="Min Stock">
                                    </div>
                                </div>
                                <!-- /col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>Max Stock</label>
                                        <input type="text" class="form-control" placeholder="Max Stock">
                                    </div>
                                </div>
                                <!-- /col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>Re Order Level</label>
                                        <input type="text" class="form-control" placeholder="Re Order Level">
                                    </div>
                                </div>
                                <!-- /col -->
                            </div>
                            <!--/ row -->
                            <!-- card -->
                            <div class="card">
                                <div class="card-header">
                                    <h6>MRp - SRate with Multiple Rates</h6>
                                </div>
                                <div class="card-body">
                                    <!-- row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>PRate 1</label>
                                                <input type="text" class="form-control" placeholder="PRate 1">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>SRate 1</label>
                                                <input type="text" class="form-control" placeholder="SRate 1">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>MRP 1</label>
                                                <input type="text" class="form-control" placeholder="MRP 1">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                    </div>
                                    <!--/ row -->
                                    <!-- row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>PRate 2</label>
                                                <input type="text" class="form-control" placeholder="PRate 2">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>SRate 2</label>
                                                <input type="text" class="form-control" placeholder="SRate 2">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>MRP 2</label>
                                                <input type="text" class="form-control" placeholder="MRP 2">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                    </div>
                                    <!--/ row -->
                                    <!-- row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>PRate 3</label>
                                                <input type="text" class="form-control" placeholder="PRate 3">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>SRate 3</label>
                                                <input type="text" class="form-control" placeholder="SRate 3">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>MRP 3</label>
                                                <input type="text" class="form-control" placeholder="MRP 3">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                    </div>
                                    <!--/ row -->
                                    <!-- row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>PRate 4</label>
                                                <input type="text" class="form-control" placeholder="PRate 4">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>SRate 4</label>
                                                <input type="text" class="form-control" placeholder="SRate 4">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                        <!-- col -->
                                        <div class="col-lg-4 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>MRP 4</label>
                                                <input type="text" class="form-control" placeholder="MRP 4">
                                            </div>
                                        </div>
                                        <!-- /col -->
                                    </div>
                                    <!--/ row -->
                                </div>
                            </div>
                            <!--/ card -->
                            <!--/ address -->
                        </div>
                        <div role="tabpanel" class="tab-pane" id="AccountDetails">
                            <!-- Accoutn Details -->
                            <!-- row -->
                            <div class="row">
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>GST Tax Rates</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>5.00</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row-->
                            <div class="row">
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>CGST</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>2.50</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>CGST Input 2.5%</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>CGST Output 2.5%</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row-->
                            <div class="row">
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>SGST</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>2.50</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>CGST Input 2.5%</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>CGST Output 2.5%</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row-->
                            <div class="row">
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>IGST</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>2.50</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>CGST Input 2.5%</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>CGST Output 2.5%</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- row-->
                            <div class="row">
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label>CESS</label>
                                            <input type="text" class="form-control" placeholder="CESS">
                                        </div>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                                <!-- col -->
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select</option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                            <!--/ row -->
                            <!-- card -->
                            <div class="card">
                                <div class="card-header">
                                    <h6>Local</h6>
                                </div>
                                <div class="card-body">
                                    <!-- row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Purchase A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Purchasae 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Sales A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Sales 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Purchase Return A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Purchasae 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Sale Return A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Sales 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Credit Note A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Credit Note 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Debit Note A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Debit Note 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>GST Service Bill A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                    </div>
                                    <!--/ row -->
                                </div>
                            </div>
                            <!--/ card -->
                            <!-- card -->
                            <div class="card">
                                <div class="card-header">
                                    <h6>Non Local</h6>
                                </div>
                                <div class="card-body">
                                    <!-- row -->
                                    <div class="row">
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Purchase A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Purchasae 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Sales A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Sales 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Purchase Return A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Purchasae 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Sale Return A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Sales 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Credit Note A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Credit Note 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Debit Note A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Debit Note 5%</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                        <!-- col -->
                                        <div class="col-lg-3 col-md-4 col-sm-6">
                                            <div class="form-group">
                                                <label>IGST Service Bill A/c</label>
                                                <select class="form-control show-tick ms select2"
                                                    data-placeholder="Select">
                                                    <option>Select</option>
                                                    <option>Select Item1</option>
                                                    <option>Select Item2</option>
                                                    <option>Select Item3</option>
                                                    <option>Select Item4</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--/ col -->
                                    </div>
                                    <!--/ row -->
                                </div>
                            </div>
                            <!--/ card -->
                            <!--/ Account Details -->
                        </div>
                        <div role="tabpanel" class="tab-pane" id="CustomFields">
                            <!-- custom fields -->
                            <div class="table-responsive">
                                <table class="table m-b-0 kliqtable">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row"> Beverates </th>
                                            <td>123</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> Food Items </th>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> Silver Customers </th>
                                            <td>Silver</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> VIP Customers </th>
                                            <td>VIP</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--/ customfields -->
                        </div>
                    </div>
                </div>
                <!--/ bootstrap tabs -->
            </div>
            <!--/ card body -->
            <div class="card-footer text-left w-100">
               
                <button class="btn redbtn" type="button">Another</button>
                <button class="btn redbtn" type="button">F3-Save</button>
                <button class="btn redbtn" type="button">Find</button>
               
                <button class="btn redbtn" type="button">Clear</button>
                <button class="btn redbtn" type="button">Close</button>
                <button class="btn redbtn" type="button">Help</button>
            </div>
        </div>
    </main>
    <div class="modal fade" id="addItem" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="mainheader">
                    
                        <h4 class="title" id="largeModalLabel">Create Item</h4>
                    
                </div>
                <!-- body -->
                <div class="modal-body">
                    <!-- row -->
                    <div class="row">
                       
                        <div class="col-md-3 modal-sidebar">
                            <h5>Select Location</h5>
                            <div class="pt-3">
                                
                                <div class="checkbox">
                                    <input id="locNellore" type="checkbox">
                                    <label for="locNellore"> Accounts </label>
                                </div>
                                <div class="checkbox">
                                    <input id="locOngole" type="checkbox">
                                    <label for="locOngole"> Adminstration </label>
                                </div>
                                <div class="checkbox">
                                    <input id="locSuryapet" type="checkbox">
                                    <label for="locSuryapet"> New Division1 </label>
                                </div>
                                <div class="checkbox">
                                    <input id="locVijayawada" type="checkbox">
                                    <label for="locVijayawada"> New Division 2 </label>
                                </div>
                               
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="d-flex justify-content-between">
                                <h5>Area</h5>
                                <div class="checkbox">
                                    <span class="d-inline-block pr-2">Status</span>
                                    <input id="act01" type="checkbox">
                                    <label for="act01"> Active </label>
                                </div>
                            </div>
                            <div class="border p-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Division Name</label>
                                            <input type="text" class="form-control" placeholder="Write Area Name">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Division code</label>
                                            <input type="text" class="form-control" placeholder="Write Area code">
                                        </div>
                                    </div>
                                   
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Select Branch</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Area Under</option>
                                                <option>Select Item1</option>
                                                <option>Select Item2</option>
                                                <option>Select Item3</option>
                                                <option>Select Item4</option>
                                            </select>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--/ row -->
                </div>
                <!-- body -->
                <div class="card-footer text-left w-100">
                    <button class="btn redbtn" type="button">New</button>
                   
                    <button class="btn redbtn" type="button">F3-Save</button>
                    <button class="btn redbtn" type="button">Edit</button>
                   
                    <button class="btn redbtn" type="button">Delete</button>
                   
                    <button class="btn redbtn"  data-dismiss="modal" type="button">Close</button>
                    <button class="btn redbtn" type="button">Cancel</button>
                    <button class="btn redbtn" type="button">Help</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="hsn" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="mainheader">
                    
                        <h4 class="title" id="largeModalLabel">Create Item</h4>
                    
                </div>
                <!-- body -->
                <!-- <app-hsn-creation></app-hsn-creation>w -->
                <!-- body -->
                <div class="card-footer text-left w-100">
                    <button class="btn redbtn" type="button">New</button>
                   
                    <button class="btn redbtn" type="button">F3-Save</button>
                    <button class="btn redbtn" type="button">Edit</button>
                   
                    <button class="btn redbtn" type="button">Delete</button>
                   
                    <button class="btn redbtn"  data-dismiss="modal" type="button">Close</button>
                    <button class="btn redbtn" type="button">Cancel</button>
                    <button class="btn redbtn" type="button">Help</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="category" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="mainheader">
                    
                        <h4 class="title" id="largeModalLabel">Create Item</h4>
                    
                </div>
                <!-- body -->
                <div class="modal-body">
                    <!-- row -->
                    <div class="row">
                       
                        <div class="col-md-3 modal-sidebar">
                            <h5>Select Location</h5>
                            <div class="pt-3">
                                
                                <div class="checkbox">
                                    <input id="locNellore" type="checkbox">
                                    <label for="locNellore"> Accounts </label>
                                </div>
                                <div class="checkbox">
                                    <input id="locOngole" type="checkbox">
                                    <label for="locOngole"> Adminstration </label>
                                </div>
                                <div class="checkbox">
                                    <input id="locSuryapet" type="checkbox">
                                    <label for="locSuryapet"> New Division1 </label>
                                </div>
                                <div class="checkbox">
                                    <input id="locVijayawada" type="checkbox">
                                    <label for="locVijayawada"> New Division 2 </label>
                                </div>
                               
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="d-flex justify-content-between">
                                <h5>Category</h5>
                                <div class="checkbox">
                                    <span class="d-inline-block pr-2">Status</span>
                                    <input id="act01" type="checkbox">
                                    <label for="act01"> Active </label>
                                </div>
                            </div>
                            <div class="border p-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Category Name</label>
                                            <input type="text" class="form-control" placeholder="Write Area Name">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Category code</label>
                                            <input type="text" class="form-control" placeholder="Write Area code">
                                        </div>
                                    </div>
                                   
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Discription</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select Area Under</option>
                                                <option>Select Item1</option>
                                                <option>Select Item2</option>
                                                <option>Select Item3</option>
                                                <option>Select Item4</option>
                                            </select>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--/ row -->
                </div>
                <!-- body -->
                <div class="card-footer text-left w-100">
                    <button class="btn redbtn" type="button">New</button>
                   
                    <button class="btn redbtn" type="button">F3-Save</button>
                    <button class="btn redbtn" type="button">Edit</button>
                   
                    <button class="btn redbtn" type="button">Delete</button>
                   
                    <button class="btn redbtn"  data-dismiss="modal" type="button">Close</button>
                    <button class="btn redbtn" type="button">Cancel</button>
                    <button class="btn redbtn" type="button">Help</button>
                </div>
            </div>
        </div>
    </div>
    <!-- main body -->
</div>